import React, { useCallback, useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import dayjs from "dayjs";

import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

import moment from "moment";
import CommonService from "../../services/common.service";

const WorkshopReport = ({ depo }) => {
  const [activeYearly, setActiveYearly] = useState(3);
  const [checked, setChecked] = useState("3");
  const [loading, setLoading] = useState(false);

  const [showCalendar, setShowCalendar] = useState(false);
  const [showCalendar2, setShowCalendar2] = useState(false);

  const [formdate, setFormdate] = useState();
  const [toDate, setToDate] = useState();

  const [data, setData] = useState([]);

  const fetchBusCounts = useCallback(() => {
    const payload = {
      locno: depo,
      status: checked,
      rangetype: activeYearly.toString(),
    };
    setLoading(true);

    CommonService.getBuscount(payload)
      .then((resp) => {
        setLoading(false);
        setData(resp.data);
      })
      .catch((e) => console.log(e));
  }, [checked, activeYearly]);

  useEffect(() => {
    fetchBusCounts();
  }, [fetchBusCounts]);

  const [details, setDetails] = useState({
    fromDate: "",
    formatedFromDate: "",
    toDate: "",
    formatedToDate: "",
  });

  const currentDate = new Date();

  const formatMonthYear = (locale, date) => {
    return `${currentDate.getDate()} ${currentDate.toLocaleDateString(locale, {
      month: "long",
    })}, ${currentDate.getFullYear()}`;
  };

  const disableWeekends = ({ date, view }) => {
    // Disable weekends
    if (view === "month") {
      return date.getDay() === 0 || date.getDay() === 6;
    }
  };

  const handleChange = (newValue) => {
    setFormdate(newValue);
    setDetails({
      ...details,
      fromDate: moment(new Date(newValue)).format("YYYY-MM-DD"),
      formatedFromDate: moment(new Date(newValue)).format("DD-MM-YY"),
    });
    setShowCalendar(false);
  };

  const handleChange2 = (newValue) => {
    setToDate(newValue);
    setDetails({
      ...details,
      toDate: moment(new Date(newValue)).format("YYYY-MM-DD"),
      formatedToDate: moment(new Date(newValue)).format("DD-MM-YY"),
    });
    setShowCalendar2(false);
  };

  const handleYearlyFilter = (from) => {
    setActiveYearly(from);
  };

  const generateLast7DaysData = () => {
    if (data.length != 0) {
      const data2 = data.map((item) =>
        moment(item.yearorMonth, "DD-MM-YYYY hh:mm:ss").format("DD-MM-YY")
      );

      return data2;
    } else {
      return;
    }
  };

  const generateLast7YearsData = () => {
    if (data.length != 0) {
      const data2 = data.map((itm) => itm.yearorMonth);
      return data2;
    } else {
      return;
    }
  };

  const months = Array.from({ length: dayjs().month() + 1 }, (_, i) =>
    dayjs().month(i).format("MMM")
  );

  const xdata =
    activeYearly === 3
      ? generateLast7DaysData()
      : activeYearly === 1
      ? months
      : activeYearly === 2
      ? generateLast7YearsData()
      : [];

  const gradient = document.createElement("canvas").getContext("2d");
  const gradientFill = gradient.createLinearGradient(0, 0, 0, 250);
  const gradientFill2 = gradient.createLinearGradient(0, 0, 0, 250);
  const gradientFill3 = gradient.createLinearGradient(0, 0, 0, 250);

  gradientFill.addColorStop(0, "rgba(193, 255, 230, 1)"); // Start color
  gradientFill.addColorStop(1, "rgba(255, 255, 255, 1)"); // End color

  gradientFill2.addColorStop(0, "rgba(200, 181, 237, 1)"); // Start color
  gradientFill2.addColorStop(1, "rgba(255, 255, 255, 1)"); // End color

  gradientFill3.addColorStop(0, "rgba(247, 207, 238, 1)"); // Start color
  gradientFill3.addColorStop(1, "rgba(255, 255, 255, 1)"); // End color

  const chartData = {
    labels: xdata,
    datasets: [
      {
        label: "Total Bus",
        data: data.map((item) => item.buscount),
        backgroundColor: gradientFill3,
        borderColor: "rgba(236, 137, 214, 1)",
        categoryPercentage: 0.34,
        fill: true,
        borderWidth: 0.5,
        tension: 0.5,
      },
    ],
  };

  const chartData2 = {
    labels: xdata,
    datasets: [
      {
        label: "Under maintenance",
        data: data.map((item) => item.buscount),
        backgroundColor: gradientFill2,
        borderColor: "rgba(172, 145, 228, 1)",
        categoryPercentage: 0.34,
        fill: true,
        borderWidth: 0.5,
        tension: 0.5,
      },
    ],
  };

  const chartData3 = {
    labels: xdata,
    datasets: [
      {
        label: "Maintenance completed",
        data: data.map((item) => item.buscount),
        backgroundColor: gradientFill,
        borderColor: "rgba(45, 206, 137, 1)",
        categoryPercentage: 0.34,
        fill: true,
        borderWidth: 0.5,
        tension: 0.5,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: false,
        text: "Bus Count",
      },
      tooltip: {
        mode: "index",
      },
      legend: {
        display: false,
        labels: {
          boxWidth: 20,
          boxHeight: 20,
          filter: function (legendItem, data) {
            return legendItem.index !== 1;
          },
        },
      },
      tooltip: {
        displayColors: false,
        yAlign: "bottom",
        backgroundColor: "rgba(254, 235, 230, 1)",
        titleColor: "black",
        bodyColor: "black",
        footerColor: "black",
        bodyFont: {
          size: 17,
          family: "Jost, sans-serif",
        },
        titleFont: {
          size: 15,
          family: "Jost, sans-serif",
        },
      },
      datalabels: {
        display: false,
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: {
        grid: {
          drawOnChartArea: true,
          display: false,
        },
        border: {
          display: false,
        },
        ticks: {
          font: {
            size: 13,
            weight: "bold",
            family: "Jost",
          },
        },
      },
      y: {
        type: "linear",
        beginAtZero: true,
        grid: {
          drawOnChartArea: true,
        },
        ticks: {
          beginAtZero: true,
          stepSize: 100,
          font: {
            size: 12,
            weight: "normal",
            family: "Jost",
          },
        },
        suggestedMin: 0,
        suggestedMax: 10,
        title: {
          display: true,
          text: "Bus Count",
        },
      },
    },
    elements: {
      point: {
        radius: 0,
      },
    },
  };

  return (
    <>
      <div className="graph-header">
        <div className="graph-heading">Workshop Reports</div>
        <div className="graph-yearly-filter">
          <div
            className={activeYearly === 3 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(3)}
          >
            Last 7 Days
          </div>
          <div
            className={activeYearly === 1 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(1)}
          >
            Monthly
          </div>
          <div
            className={activeYearly === 2 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(2)}
          >
            Yearly
          </div>
        </div>
        <div className="date-range">
          <div className="flex position-relative">
            <span>
              {details.formatedFromDate !== ""
                ? details.formatedFromDate
                : "From"}
            </span>
            <span>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={(e) => {
                  setShowCalendar(true);
                  setShowCalendar2(false);
                }}
              >
                <path
                  d="M2.5 8.33333H17.5M5.83333 2.5V4.16667M14.1667 2.5V4.16667M5.16667 17.5H14.8333C15.7667 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1586 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7667 17.5 14.8333V6.83333C17.5 5.89991 17.5 5.4332 17.3183 5.07668C17.1586 4.76307 16.9036 4.50811 16.59 4.34832C16.2335 4.16667 15.7667 4.16667 14.8333 4.16667H5.16667C4.23325 4.16667 3.76653 4.16667 3.41002 4.34832C3.09641 4.50811 2.84144 4.76307 2.68166 5.07668C2.5 5.4332 2.5 5.89991 2.5 6.83333V14.8333C2.5 15.7667 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76653 17.5 4.23324 17.5 5.16667 17.5Z"
                  stroke="#6E6284"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            {showCalendar && (
              <div className="calendarModal position-absolute">
                <Calendar
                  formatMonthYear={formatMonthYear}
                  tileDisabled={disableWeekends}
                  onChange={handleChange}
                  value={formdate}
                />
              </div>
            )}
          </div>
          <div className="flex position-relative">
            <span>
              {details.formatedToDate !== "" ? details.formatedToDate : "To"}
            </span>
            <span>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={(e) => {
                  setShowCalendar2(true);
                  setShowCalendar(false);
                }}
              >
                <path
                  d="M2.5 8.33333H17.5M5.83333 2.5V4.16667M14.1667 2.5V4.16667M5.16667 17.5H14.8333C15.7667 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1586 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7667 17.5 14.8333V6.83333C17.5 5.89991 17.5 5.4332 17.3183 5.07668C17.1586 4.76307 16.9036 4.50811 16.59 4.34832C16.2335 4.16667 15.7667 4.16667 14.8333 4.16667H5.16667C4.23325 4.16667 3.76653 4.16667 3.41002 4.34832C3.09641 4.50811 2.84144 4.76307 2.68166 5.07668C2.5 5.4332 2.5 5.89991 2.5 6.83333V14.8333C2.5 15.7667 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76653 17.5 4.23324 17.5 5.16667 17.5Z"
                  stroke="#6E6284"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            {showCalendar2 && (
              <div className="calendarModal position-absolute">
                <Calendar
                  formatMonthYear={formatMonthYear}
                  tileDisabled={disableWeekends}
                  onChange={handleChange2}
                  value={toDate}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end gap-2">
        <label class="radio-container">
          Total Buses
          <input
            type="radio"
            checked={checked === "3"}
            onChange={() => {
              setChecked("3");
            }}
            name="workshop"
          />
          <span class="checkmark"></span>
        </label>
        <label class="radio-container">
          Under maintenance
          <input
            type="radio"
            checked={checked === "0"}
            onChange={() => {
              setChecked("0");
            }}
            name="workshop"
          />
          <span class="checkmark"></span>
        </label>
        <label class="radio-container">
          Maintenance completed
          <input
            type="radio"
            checked={checked === "1"}
            onChange={() => {
              setChecked("1");
            }}
            name="workshop"
          />
          <span class="checkmark"></span>
        </label>
      </div>

      <div className="mt-3" style={{ height: "100%" }}>
        {loading ? (
          <>
            <div className="loading-area">
              <div
                class="spinner-border"
                style={{ color: "rgb(247, 177, 140)" }}
                role="status"
              >
                <span class="sr-only"></span>
              </div>
              <span>Data is Loading...</span>
            </div>
          </>
        ) : chartData.length != 0 ||
          chartData2.length != 0 ||
          chartData3 != 0 ? (
          <>
            <div className="">
              <Line
                data={
                  checked === "3"
                    ? chartData
                    : checked === "0"
                    ? chartData2
                    : chartData3
                }
                options={options}
                width={600}
                height={275}
              />
            </div>
          </>
        ) : (
          <div
            className="table-body align-items-center"
            style={{ height: "100%" }}
          >
            No Records Found
          </div>
        )}
      </div>
    </>
  );
};

export default WorkshopReport;
